import React, { useEffect, useState } from 'react';
import { AssetLibraryManager, THREE, MaterialConfig } from '@easytwin/runtime';
import { MaterialEditor } from './material-editor';
import { MaterialConfigBuilder } from './MaterialConfigManager';
import { MaterialEditorConfig } from './type';

interface MaterialEditorContainerProps {
  material: THREE.Material;
  assetLibrary: AssetLibraryManager;
  onClose: () => void;
  onUpdate: (config: MaterialConfig) => void;
  onConfirm: (config: MaterialConfig) => void;
  onNameUpdate?: (value: string) => void;
  onNameConfirm?: (value: string) => void;
  nameReadOnly?: boolean;
  type: 'SceneMaterial' | 'ModelMaterial';
}

export function MaterialEditorContainer({
  material,
  assetLibrary,
  type,
  onClose,
  onUpdate,
  onConfirm,
  onNameUpdate,
  onNameConfirm,
  nameReadOnly,
}: MaterialEditorContainerProps) {
  // 材质编辑器UI渲染的数据
  const [config, setConfig] = useState<MaterialEditorConfig>();
  // 材质配置项与UI渲染数据互相转换的构建器
  const [builder, setBuilder] = useState<MaterialConfigBuilder>();

  useEffect(() => {
    const materialConfigBuilder = new MaterialConfigBuilder({
      material,
      assetLibrary: assetLibrary,
    });
    // 构建材质编辑器UI渲染的数据
    const materialEditorConfig = materialConfigBuilder.buildMaterialEditorConfig(material, type);
    setConfig(materialEditorConfig);
    setBuilder(materialConfigBuilder);
  }, [material, assetLibrary, type]);

  const handleUpdate = (config: MaterialEditorConfig) => {
    setConfig(config);
    if (builder) {
      // 将UI渲染的数据转换为材质配置项
      const materialConfig = builder.buildMaterialConfig(config);
      onUpdate(materialConfig);
    }
  };

  const handleConfirm = (config: MaterialEditorConfig) => {
    setConfig(config);
    if (builder) {
      // 将UI渲染的数据转换为材质配置项
      const materialConfig = builder.buildMaterialConfig(config);
      onConfirm(materialConfig);
    }
  };

  const handleClose = () => {
    onClose();
  };

  const handleNameUpdate = (value: string) => {
    onNameUpdate?.(value);
    setConfig({ ...config, name: value } as MaterialEditorConfig);
  };

  const handleNameConfirm = (value: string) => {
    onNameConfirm?.(value);
    setConfig({ ...config, name: value } as MaterialEditorConfig);
  };

  if (!config) {
    return <div />;
  }

  return (
    <MaterialEditor
      config={config}
      material={material}
      onClose={handleClose}
      onUpdate={handleUpdate}
      onConfirm={handleConfirm}
      nameReadOnly={nameReadOnly}
      onNameUpdate={handleNameUpdate}
      onNameConfirm={handleNameConfirm}
    />
  );
}

export default MaterialEditorContainer;
